import PremiumHotel from './PremiumHotel';

export default PremiumHotel;
